export default __webpack_public_path__ + "static/media/access-security-hover.eaa6862d.svg";